export default () => ({
  filtersSource: null,
  items: [],
  reportTypes: [],
  activeFilters: {
    typeId: null,
    dateRange: {
      from: null,
      to: null,
    },
    emailNotifyWhenReportReady: false,
  },
  sort: {
    value: '',
    direction: 'DESC',
  },
  pagination: {
    limit: 24,
    offset: 0,
    countTotal: 0,
  },
});
